module.exports = __webpack_public_path__ + "static/offer-m-3-f3d97be1c267255c980e5e2c62053e36.jpg";